import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';
import { merge } from 'lodash';
import LoaderTypes from './mixins/Loader';

const namespace = 'Requirements';

const Types = merge(
    {
        mutations: {
            SET_REQUIREMENTS: 'setRequirements',
        },
        actions: {
            LOAD_REQUIREMENTS: 'loadRequirements',
            LOAD_REQUIREMENTS_FREETEXT: 'loadRequirementsFreetext',
        },
    },
    LoaderTypes,
);

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
